import localStorage from "../common/localStorageService";

const key = "SHAREDO_CAPABILITIES";

const get = () => {
    return localStorage.get(key) || {};
}

const set = capabilities => {
    localStorage.set(key, capabilities);
}

const clear = () => localStorage.remove(key);

export default {
    get,
    set,
    clear
}
